export default "/images/open.png?3d5f51ea13749696b98cff88d2b66122";